import {
    Component,
    Input,
    OnInit,
    viewChild,
    input,
    model,
    output,
} from "@angular/core";
import { DualListItem } from '@app/shared/mat-dual-list/models/dual-list-item.model';
import { FormControl, ReactiveFormsModule } from "@angular/forms";
import { MatListModule } from "@angular/material/list";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";

@Component({
    selector: "inspekt-mat-dual-list",
    templateUrl: "./mat-dual-list.component.html",
    styleUrls: ["./mat-dual-list.component.scss"],
    imports: [MatListModule, MatButtonModule, MatIconModule, ReactiveFormsModule],
})
export class MatDualListComponent implements OnInit {
    private _formControlItem: FormControl;
    readonly dataSourceSelection = viewChild("dataSourceSelection");
    readonly selectedItemSelection = viewChild("selectedItemSelection");
    readonly onDataChange = output<void>();
    readonly dataSourceName = input<string>(undefined);
    readonly selectedItemName = input<string>(undefined);
    readonly dataSource = model<DualListItem[]>([]);
    private _selectedItems: DualListItem[] = [];
    @Input() set selectedItems(value) {
        this._selectedItems = value;
        if (this._formControlItem) {
            this.setFormControlValue(this._selectedItems);
        }
    }

    get selectedItems() {
        return this._selectedItems;
    }

    @Input()
    set formControlItem(value) {
        this._formControlItem = value;

        if (this._selectedItems) {
            this.setFormControlValue(this._selectedItems);
        }
    }

    get formControlItem() {
        return this._formControlItem;
    }

    constructor() {}

    ngOnInit() {
        this.sortData(this.dataSource());
        this.sortData(this._selectedItems);
    }

    public moveItemToSelected() {
        const selectedItems = (this.dataSourceSelection() as any)
            ?.selectedOptions.selected;
        if (!selectedItems || !selectedItems.length) {
            return;
        }
        const _selectedItems = selectedItems.map((selectedItem) => ({
            display: selectedItem.value.display,
            id: selectedItem.value.id,
            order: selectedItem.value.order,
            value: selectedItem.value.value,
        }));
        this._selectedItems = this._selectedItems.concat(_selectedItems);
        this.dataSource.set(
            this.dataSource().filter(
                (dataSourceItem) =>
                    _selectedItems.findIndex(
                        (_selectedItem) => dataSourceItem.id === _selectedItem.id
                    ) === -1
            )
        );
        this.emitDataChangeEvent();
    }

    public moveItemToDataSource() {
        const selectedItems = (this.selectedItemSelection() as any)
            ?.selectedOptions.selected;
        if (!selectedItems || !selectedItems.length) {
            return;
        }
        const _selectedItems = selectedItems.map((selectedItem) => ({
            display: selectedItem.value.display,
            id: selectedItem.value.id,
            order: selectedItem.value.order,
            value: selectedItem.value.value,
        }));
        this.dataSource.set(this.dataSource().concat(_selectedItems));
        this.selectedItems = this.selectedItems.filter(
            (dataSourceItem) =>
                _selectedItems.findIndex(
                    (_selectedItem) => dataSourceItem.id === _selectedItem.id
                ) === -1
        );

        this.emitDataChangeEvent();
    }

    public moveAllItemToSelected() {
        const dataSource = this.dataSource();
        if (!dataSource.length) {
            return;
        }
        dataSource.forEach((item) => {
            this._selectedItems.push(item);
        });

        this.dataSource.set([]);
        this.emitDataChangeEvent();
    }

    public moveAllItemToDataSource() {
        if (!this._selectedItems.length) {
            return;
        }

        this.dataSource.update((items) => [...items, ...this._selectedItems]);

        this._selectedItems = [];
        this.emitDataChangeEvent();
    }

    public getSelectedItem(): DualListItem[] {
        return this._selectedItems;
    }

    public getDataSource(): DualListItem[] {
        return this.dataSource();
    }

    private emitDataChangeEvent() {
        if (this._formControlItem) {
            this.setFormControlValue(this.getSelectedItem());
            this._formControlItem.markAsDirty();
        }
        // TODO: The 'emit' function requires a mandatory void argument
        this.onDataChange.emit();
    }

    private setFormControlValue(data) {
        const selectedValues = [];

        if (data.length !== 0) {
            data.forEach((t) => {
                selectedValues.push(t.value);
            });
        }

        this._formControlItem.setValue(selectedValues);
    }

    private sortData(data: DualListItem[]) {
        data = data.sort((item1, item2) =>
            item1.order > item1.order ? 1 : item2.order > item1.order ? -1 : 0
        );
    }
}
